document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.selfco-faq__item').forEach(function(item) {
    const button = item.querySelector('.selfco-faq__question');
    if (!button) return;

    button.addEventListener('click', function() {
      const isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      button.setAttribute('aria-expanded', !isOpen);
    });
  });
});
